<!-- @format -->

<template>
  <div :class="loading ? 'ui loading segment' : 'ui segment'">
    <dx-chart style="max-height: 180px; height: 180px" :data-source="chartAa">
      <dx-common-axis-settings>
        <dx-label>
          <dx-font color="black" />
        </dx-label>
      </dx-common-axis-settings>

      <dx-legend :visible="false">
        <dx-font color="black" />
      </dx-legend>
      <dx-series
        argument-field="name"
        value-field="value"
        name="Asset Class (%)"
        type="bar"
        :color="appearanceSettings.appearanceSchema.barColor1"
      />
    </dx-chart>

    <div class="ui horizontal divider">Asset Allocation</div>

    <table style="font-size: small" class="ui very compact table">
      <thead>
        <tr>
          <th>Description</th>
          <th style="text-align: center">
            Target
            <i
              class="square full icon"
              :style="'color: ' + appearanceSettings.appearanceSchema.barColor1"
            ></i>
          </th>
        </tr>
      </thead>
      <tr v-for="a in chartAa">
        <td>{{ a.name }}</td>
        <td style="text-align: center">{{ formatNr(a.value, "0,0.0") }} %</td>
      </tr>
      <tr>
        <td>
          <strong>Total</strong>
        </td>
        <td style="text-align: center">
          <strong>100 %</strong>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { getCustomPortfolio } from "@/gateway";
import numeral from "numeral";
import {
  DxChart,
  DxSeries,
  DxArgumentAxis,
  DxValueAxis,
  DxCommonAxisSettings,
  DxCommonSeriesSettings,
  DxGrid,
  DxMargin,
  DxLegend,
  DxTick,
  DxTooltip,
  DxLabel,
  DxFont,
} from "devextreme-vue/chart";
export default {
  name: "ChartProjectedAa",
  props: {
    selectedPortfolio: Object,
    appearanceSettings: Object,
    // selectedPoint: Object,
    show: Boolean,
    loading: Boolean,
    aaType: String,
  },
  components: {
    DxChart,
    DxSeries,
    DxArgumentAxis,
    DxValueAxis,
    DxCommonAxisSettings,
    DxCommonSeriesSettings,
    DxGrid,
    DxMargin,
    DxLabel,
    DxLegend,
    DxTick,
    DxTooltip,
    DxFont,
  },
  data() {
    return {
      //  chartAa: null,
      pointIncomeOptions: { visible: false },
    };
  },
  computed: {
    chartAa: function() {
      let cpid = this.selectedPortfolio.customPortfolioId;

      let finalAa = [];
      // for (var i = 0; i < this.chartProjections.length; i++) {
      let p = this.selectedPortfolio;

      if (this.selectedPortfolio.currentAssetAllocation) {
        if (p.assetAllocation.localCash != 0)
          finalAa.push({
            value: p.assetAllocation.localCash,
            current: p.currentAssetAllocation.localCash,
            name: "SA Cash",
          });
        if (p.assetAllocation.localCredit != 0)
          finalAa.push({
            value: p.assetAllocation.localCredit,
            current: p.currentAssetAllocation.localCredit,
            name: "SA Credit",
          });
        if (p.assetAllocation.localBonds != 0)
          finalAa.push({
            value: p.assetAllocation.localBonds,
            current: p.currentAssetAllocation.localBonds,
            name: "SA Bonds",
          });
        if (p.assetAllocation.localProperty != 0)
          finalAa.push({
            value: p.assetAllocation.localProperty,
            current: p.currentAssetAllocation.localProperty,
            name: "SA Prop",
          });
        if (p.assetAllocation.localEquity != 0)
          finalAa.push({
            value: p.assetAllocation.localEquity,
            current: p.currentAssetAllocation.localEquity,
            name: "SA Equity",
          });
        if (p.assetAllocation.localInfrastructure != 0)
          finalAa.push({
            value: p.assetAllocation.localInfrastructure,
            current: p.currentAssetAllocation.localInfrastructure,
            name: "SA Infrastr",
          });

        if (p.assetAllocation.globalCash != 0 || !p.assetAllocation.foreignCash)
          finalAa.push({
            value: p.assetAllocation.globalCash + p.assetAllocation.foreignCash,
            current:
              p.currentAssetAllocation.globalCash +
              p.assetAllocation.foreignCash,
            name: "Gbl Cash",
          });
        if (
          p.assetAllocation.globalBonds != 0 ||
          p.assetAllocation.foreignBonds != 0
        )
          finalAa.push({
            value:
              p.assetAllocation.globalBonds + p.assetAllocation.foreignBonds,
            current:
              p.currentAssetAllocation.globalBonds +
              p.assetAllocation.foreignBonds,
            name: "Gbl Bonds",
          });
        if (p.assetAllocation.globalInvestmentGrade != 0)
          finalAa.push({
            value: p.assetAllocation.globalInvestmentGrade,
            current: p.currentAssetAllocation.globalInvestmentGrade,
            name: "Gbl Inv Grade",
          });
        if (p.assetAllocation.globalHighYield != 0)
          finalAa.push({
            value: p.assetAllocation.globalHighYield,
            current: p.currentAssetAllocation.globalHighYield,
            name: "Gbl High Yield",
          });

        if (p.assetAllocation.globalEmergingMarketBonds != 0)
          finalAa.push({
            value: p.assetAllocation.globalEmergingMarketBonds,
            current: p.currentAssetAllocation.globalEmergingMarketBonds,
            name: "Gbl EM Bonds",
          });

        if (p.assetAllocation.africaEuroBondsExSouthAfrica != 0)
          finalAa.push({
            value: p.assetAllocation.africaEuroBondsExSouthAfrica,
            current: p.currentAssetAllocation.africaEuroBondsExSouthAfrica,
            name: "Afr. Eur Bonds ex SA",
          });

        if (
          p.assetAllocation.globalProperty != 0 ||
          p.assetAllocation.foreignProperty != 0
        )
          finalAa.push({
            value:
              p.assetAllocation.globalProperty +
              p.assetAllocation.foreignProperty,
            current:
              p.currentAssetAllocation.globalProperty +
              p.assetAllocation.foreignProperty,
            name: "Gbl Prop",
          });

        if (
          p.assetAllocation.globalEquity != 0 ||
          p.assetAllocation.foreignEquity != 0
        )
          finalAa.push({
            value:
              p.assetAllocation.globalEquity + p.assetAllocation.foreignEquity,
            current:
              p.currentAssetAllocation.globalEquity +
              p.assetAllocation.foreignEquity,
            name: "Gbl Equity",
          });

        if (p.assetAllocation.globalEquitySmallCapStocks != 0)
          finalAa.push({
            value: p.assetAllocation.globalEquitySmallCapStocks,
            current: p.currentAssetAllocation.globalEquitySmallCapStocks,
            name: "Gbl Eq Small Cap",
          });

        if (p.assetAllocation.globalEmergingMarketEquity != 0)
          finalAa.push({
            value: p.assetAllocation.globalEmergingMarketEquity,
            current: p.currentAssetAllocation.globalEmergingMarketEquity,
            name: "Gbl EM Eq",
          });

        if (p.assetAllocation.globalHedgeFunds != 0)
          finalAa.push({
            value: p.assetAllocation.globalHedgeFunds,
            current: p.currentAssetAllocation.globalHedgeFunds,
            name: "Gbl Hedge Funds",
          });

        if (p.assetAllocation.listedPrivateEquity != 0)
          finalAa.push({
            value: p.assetAllocation.listedPrivateEquity,
            current: p.currentAssetAllocation.listedPrivateEquity,
            name: "Gbl Priv Equ",
          });

        if (p.assetAllocation.listedInfrastructure != 0)
          finalAa.push({
            value: p.assetAllocation.listedInfrastructure,
            current: p.currentAssetAllocation.listedInfrastructure,
            name: "Gbl Infrastr",
          });

        if (p.assetAllocation.globalIncomeOpportunities != 0)
          finalAa.push({
            value: p.assetAllocation.globalIncomeOpportunities,
            current: p.currentAssetAllocation.globalIncomeOpportunities,
            name: "Gbl Inc Opp",
          });
      }

      return finalAa;
    },
  },
  methods: {
    formatNr(val, fmt) {
      if (fmt) return numeral(val).format(fmt);
      else return numeral(val).format("0,0.0a");
    },

    async init() {
      const response = await getCustomPortfolio({
        id: this.selectedPortfolio.customPortfolioId,
        aaType: this.aaType,
      });

      if (response) {
        console.log("asset allocation mounted", response.portfolioView);
        this.selectedPortfolio.assetAllocation =
          response.portfolioView.assetAllocation;
        this.selectedPortfolio.currentAssetAllocation =
          response.portfolioView.currentAssetAllocation;
      }
    },
  },
  async mounted() {
    //console.log("asset allocation mounted");
    //await this.init();
  },
};
</script>
